import type { AgentSummary } from '@/hooks/useAIAgents';

export const DEFAULT_AGENT_NAME = 'hannibal';

/**
 * A hunt root agent must be a capability-mode agent that accepts a Hunt
 * target. Filtering client-side keeps the /agents contract generic.
 */
export function isHuntRootAgent(agent: AgentSummary): boolean {
  return Boolean(agent.capability) && (agent.target ?? []).includes('hunt');
}
